import {networkResetDeviceConstants} from "../constants/network-reset-device.constants";

const initState = {
    list: null,
    singleItem: null,
    refreshLock: false,
    validateErrors: null,
    singleItemError: null,
}

export function networkResetDeviceReducer(state = initState, action) {
    switch (action.type) {
        case networkResetDeviceConstants.NETWORK_RESET_DEVICE_LIST_REQUEST:
            return {
                ...state
            }
        case networkResetDeviceConstants.NETWORK_RESET_DEVICE_LIST_SUCCESS:
            return  {
                ...state,
                list: action.list,
                refreshLock: false,
                validateErrors: null
            }
        case networkResetDeviceConstants.NETWORK_RESET_DEVICE_LIST_FAILURE:
            return  {
                ...state,
                list: null,
                refreshLock: false,
                validateErrors: action.error
            }
        case networkResetDeviceConstants.NETWORK_RESET_DEVICE_LIST_CLEAR:
            return  {
                ...state,
                list: null,
                refreshLock: false,
                validateErrors: null
            }
        case networkResetDeviceConstants.NETWORK_RESET_DEVICE_BY_ID_REQUEST:
            return  {
                ...state,
                singleItem: null,
                singleItemError: null
            }
        case networkResetDeviceConstants.NETWORK_RESET_DEVICE_BY_ID_SUCCESS:
            return {
                ...state,
                singleItem: action.item
            }
        case networkResetDeviceConstants.NETWORK_RESET_DEVICE_BY_ID_FAILURE:
            return {
                ...state,
                singleItemError: action.error
            }
        default:
            return state;
    }
}
